import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { I18NextPipe } from 'angular-i18next';
import { CardGroupComponent, FormGroupComponent, InputComponent, InputPasswordComponent } from 'mbs-ui-kit';
import { StorageType } from 'mbs-ui-shared';
import { e2eLocators, fakeSecretKey } from '../credential-forms.constants';
import { ImpossibleCloudCredentialForm } from '../credential-forms.model';

@UntilDestroy()
@Component({
  selector: 'mbs-credential-form-impossible-cloud',
  templateUrl: './credential-form-impossible-cloud.component.html',
  styleUrls: ['../credential-forms.style.scss'],
  imports: [I18NextPipe, CardGroupComponent, InputComponent, FormGroupComponent, InputPasswordComponent, ReactiveFormsModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CredentialFormImpossibleCloudComponent implements OnInit {
  @Input() form: ImpossibleCloudCredentialForm;

  public readonly StorageType = StorageType;
  public readonly fakeSecretKey = fakeSecretKey;
  public readonly e2eLocators = e2eLocators;

  ngOnInit(): void {
    this.accessKey.valueChanges.pipe(untilDestroyed(this)).subscribe(() => {
      this.secretKey.patchValue('');
      this.secretKey.updateValueAndValidity();
      this.secretKey.markAsDirty();
      this.secretKey.markAsTouched();
    });
  }

  get accessKey(): FormControl {
    return this.form.get('accessKey') as FormControl;
  }

  get secretKey(): FormControl {
    return this.form.get('secretKey') as FormControl;
  }
}
